import { useState, useRef, useEffect } from 'react';
import { HelpCircle, X } from 'lucide-react';

export default function HelpBubble({ title, steps }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <div className="relative inline-block" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="p-1.5 rounded-full hover:bg-blue-100 text-slate-400 hover:text-blue-600 transition-colors"
        aria-label="Help"
        data-testid="help-bubble-trigger"
      >
        <HelpCircle className="h-5 w-5" />
      </button>
      {open && (
        <div className="absolute right-0 top-10 z-50 w-80 bg-white border border-slate-200 rounded-lg shadow-xl animate-in fade-in slide-in-from-top-2 duration-200">
          <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 bg-slate-50 rounded-t-lg">
            <h4 className="text-sm font-semibold text-slate-800">{title}</h4>
            <button onClick={() => setOpen(false)} className="p-0.5 hover:bg-slate-200 rounded">
              <X className="h-4 w-4 text-slate-500" />
            </button>
          </div>
          <div className="px-4 py-3 max-h-72 overflow-y-auto">
            <ol className="space-y-2">
              {steps.map((step, i) => (
                <li key={i} className="flex gap-2 text-xs text-slate-700 leading-relaxed">
                  <span className="font-bold text-blue-600 shrink-0">{i + 1}.</span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      )}
    </div>
  );
}
